import React, { useState } from 'react'
import TabView from '../../components/tabview'
import CompletedTraining from './CompletedTraining'
import DashboardLayout from '../../components/layouts/dashboard'
import TrainingPage from '../../pages/employee-training'

const EmployeeTraining = () => {
  const [activeTab, setActiveTab] = useState(1)
  const TrainingTabs = [
    {
      title: 'Ongoing Trainings',
      Content: TrainingPage,
    },
    {
      title: 'Completed Trainings',
      Content: CompletedTraining,
    },
  ]
  return (
    <DashboardLayout title='Training Management'>
      <div className='font-bold text-lg mb-3 text-hr-primary-1'>My Trainings</div>
      <div className='mt-2'>
        <TabView
          Tabs={TrainingTabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </DashboardLayout>
  )
}

export default EmployeeTraining
